/**
 * Schedules a callback after two animation frames.
 *
 * One RAF is enough to let the browser commit a pending DOM mutation, but a
 * second RAF is required to guarantee that the subsequent layout/paint pass has
 * also completed. Use this when you need to measure DOM geometry (e.g. column
 * widths) that will only be correct after a React re-render has been flushed
 * and the browser has performed layout.
 *
 * @example
 * // Re-select a field after moving it so that the highlight overlay measures
 * // the correct (post-swap) column width.
 * dispatch(doMoveField(...));
 * afterNextLayout(() => selectionsApi.selectFields(fieldIds));
 */
export function afterNextLayout(callback: () => void): void {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback);
  });
}
